import {
  ifElse,
  either,
  isNil,
  isEmpty,
  always,
  pipe,
  toPairs,
  filter,
  map,
  join,
} from 'ramda'

/**
 * This function takes an object and converts it into a query param string.
 * Example response: ?uuid=mem_12345&name=John
 */
export const makeQueryParams = (object: Record<string, any>): string =>
  ifElse(
    either(isNil, isEmpty),
    always(''),
    pipe(
      toPairs as (obj: Record<string, any>) => [string, any][], // Cast to avoid type errors
      filter(([, v]) => !isNil(v) && !isEmpty(v)),
      map(([k, v]) => [encodeURIComponent(k), encodeURIComponent(String(v))]), // Ensure values are strings
      map(join('=')),
      join('&'),
      (queryParams: string) => (queryParams ? `?${queryParams}` : ''),
    ),
  )(object)
